import React from 'react';
import { CustomerDebt } from '../types';
import { formatCurrency } from '../utils/currency';

interface CustomerDebtTableProps {
  customerDebts: CustomerDebt[];
}

const CustomerDebtTable: React.FC<CustomerDebtTableProps> = ({ customerDebts }) => {

  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th className="text-start">Customer</th>
            <th className="text-start">Total Amount Debt</th>
          </tr>
        </thead>
        <tbody>
          {customerDebts.map((debt, index) => (
            <tr key={index}>
              <td>{debt.customer}</td>
              <td className="text-danger">
                {formatCurrency(debt.totalAmountDebt, 'USD')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerDebtTable;
